import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import { COMPACT_QUERY } from "../../../../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

export default function DocumentSkeleton() {
  return (
    <Paper>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Skeleton variant="text" width={120} height={32} />
          <Skeleton variant="text" width={160} height={28} />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Skeleton variant="text" width={120} height={20} />
          <Skeleton
            variant="rounded"
            width={90}
            height={36}
            sx={{ borderRadius: 2 }}
          />
        </Box>
      </Box>

      <Divider sx={{ my: 2, [compact]: { my: 1.5 } }} />

      <Box sx={{ display: "flex", gap: 1, mb: 2, [compact]: { mb: 1.5 } }}>
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="text" width={100} height={24} />
        <Skeleton variant="circular" width={20} height={20} sx={{ ml: 2 }} />
      </Box>
      <Grid container spacing={1}>
        {[5, 3, 4].map((size, idx) => (
          <Grid key={idx} size={{ xs: size }}>
            <Skeleton variant="text" width={80} height={20} />
          </Grid>
        ))}
        {[5, 3, 4].map((size, idx) => (
          <Grid  key={idx} size={{ xs: size }}>
            <Skeleton variant="text" width={150} height={28} />
          </Grid>
        ))}
      </Grid>

      <Divider sx={{ my: 3, [compact]: { my: 1.5 } }} />

      <Box sx={{ display: "flex", gap: 6, [compact]: { gap: 3, flexWrap: "wrap" } }}>
        <Box sx={{ display: "flex", gap: 1, mb: 3, [compact]: { mb: 1.5 } }}>
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="text" width={100} height={24} />
        </Box>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Skeleton variant="text" width={80} height={28} />
          <Skeleton variant="text" width={100} height={28} />
        </Box>
      </Box>

      <Divider sx={{ mb: 3, [compact]: { mb: 1.5 } }} />

      {/* รายการ */}
      <Skeleton
        variant="text"
        width={80}
        height={28}
        sx={{ mb: 2, [compact]: { mb: 1 } }}
      />

      {/* Table Skeleton */}
      <Box sx={{ width: "100%", overflow: "hidden" }}>
        {[...Array(5)].map((_, row) => (
          <Box
            key={row}
            sx={{
              display: "flex",
              width: "100%",
              px: 1,
              py: 0.5,
              bgcolor: row % 2 ? "#f6f6f9" : "#fff",
            }}
          >
            {[60, 220, 60, 80, 80, 80, 100].map((w, col) => (
              <Skeleton
                key={col}
                variant="rectangular"
                width={w}
                height={32}
                sx={{ borderRadius: 1, mx: 0.5 }}
              />
            ))}
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          gap: 10,
          width: "fit-content",
          display: "flex",
          padding: "24px",
          margin: "24px 0 24px auto",
          bgcolor: "#FFCF8F36",
          borderRadius: 3,
          [compact]: {
            gap: 4,
            padding: "12px 16px",
            margin: "16px 0 16px auto",
          },
        }}
      >
        <Skeleton variant="text" width={140} height={32} />
        <Skeleton variant="text" width={120} height={32} />
      </Box>
    </Paper>
  );
}
